import axios from 'axios';
const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api' });
api.interceptors.request.use(config => {
  const token = localStorage.getItem('meetingnotes_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use(res => res, err => {
  if (err.response?.status === 401 || err.response?.status === 403) {
    localStorage.removeItem('meetingnotes_token');
    window.location.href = '/login';
  }
  return Promise.reject(err);
});
export const authApi = {
  checkSetup: () => api.get('/auth/check-setup'),
  setup: (d) => api.post('/auth/setup', d),
  login: (d) => api.post('/auth/login', d),
};
export const meetingsApi = {
  list: () => api.get('/meetings'),
  get: (id) => api.get(`/meetings/${id}`),
  create: (d) => api.post('/meetings', d),
  update: (id, d) => api.put(`/meetings/${id}`, d),
  delete: (id) => api.delete(`/meetings/${id}`),
  upload: (id, formData) => api.post(`/meetings/${id}/upload`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 300000 }),
  transkribieren: (id) => api.post(`/meetings/${id}/transkribieren`),
  status: (id) => api.get(`/meetings/${id}/status`),
};
export default api;
